import React, { useState } from "react";
import { Modal } from "rsuite";
import { DataInput, Button } from "../../../components";
import ToastService from "../../../services/toast.service";
import WinzRatesService from "../winzrates.service";
import logger from "../../../utils/logger";

function CreateWinzRateModal({ open, onClose, onSave }) {
  const [formData, setFormData] = useState({
    rateCode: "",
    maxRate: ""
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const validateForm = () => {
    // Check if user has attempted to enter values (even if invalid)
    const hasRateCode = formData.rateCode !== "";
    const hasMaxRate = formData.maxRate !== "";
    
    if (!hasRateCode || !hasMaxRate) {
      ToastService.error("Please fill in all required fields");
      return false;
    }
    
    // Validate rate code: must be a number
    const rateCode = parseInt(formData.rateCode);
    if (isNaN(rateCode) || rateCode < 0) {
      ToastService.error("Rate Code must be a valid positive number");
      return false;
    }
    
    // Validate max rate: must be a valid number
    const maxRate = parseFloat(formData.maxRate);
    if (isNaN(maxRate) || maxRate < 0) {
      ToastService.error("Max Rate must be a valid positive number");
      return false;
    }
    
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setLoading(true);
    try {
      await WinzRatesService.createWinzRate({
        rateCode: parseInt(formData.rateCode),
        maxRate: parseFloat(formData.maxRate)
      });
      ToastService.success("Winz rate created successfully");
      if (onSave) onSave(formData);
      setFormData({ rateCode: "", maxRate: "" });
      onClose();
    } catch (error) {
      logger.error("Error creating winz rate:", error);
      ToastService.error(`Failed to create winz rate: ${error.message || "Unknown error"}`);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setFormData({ rateCode: "", maxRate: "" });
    onClose();
  };

  return (
    <Modal open={open} onClose={handleCancel} size="md" className="create-winz-rate-modal">
      <Modal.Header>
        <Modal.Title>Create Winz Rate</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="create-winz-rate-container">
          <DataInput
            label="Rate Code"
            placeholder="Enter Rate Code"
            type="number"
            min="0"
            value={formData.rateCode}
            onChange={e => handleInputChange("rateCode", e.target.value)}
          />
          <DataInput
            label="Max Rate"
            placeholder="0.00"
            type="number"
            min="0"
            step="0.01"
            value={formData.maxRate}
            onChange={e => handleInputChange("maxRate", e.target.value)}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={handleSubmit}
          loading={loading}
          disabled={loading}
          text="Create"
        />
        <Button
          onClick={handleCancel}
          disabled={loading}
          text="Cancel"
          appearance="subtle"
        />
      </Modal.Footer>
    </Modal>
  );
}

export default CreateWinzRateModal;
